const contentStyle = {
  "& .MuiCardContent-root": {
    p: "unset !important",
  },
  height: "calc(100vh - 138px)",
  m: "unset",
  p: "unset !important",
};

const mainCardStyle = {
  m: "unset",
  borderRadius: "unset",
  p: "32px 32px 0px 32px",
  border: "none",
  height: "100vh",
};

const grid12Style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const grid11Style = {
  display: "flex",
  alignItems: "center",
};
const hideOnXS = {
  display: {
    md: "flex",
    xs: "none",
  },
  alignItems: "center",
};
const hideOnSmMdLg = {
  display: {
    md: "none",
    xs: "flex",
  },
  alignItems: "center",
};
const searchFieldStyle = {
  width: { xs: "100%", md: "260px" },
  height: "44px",
  marginLeft: { xs: "unset", sm: "5px", md: "10px", lg: "48px" },
  marginTop: { xs: "12px", sm: "unset" },

  "& .MuiOutlinedInput-input": {
    background: "#F5F5F5",
    padding: "10px 16px 10px 0px !important",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "unset",
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#F5F5F5",
  },
};

export const filterSearchField = {
  ...searchFieldStyle,

  width: "100%",
  p: "4px 17px 0",
  m: "0px !important",
};

const searchFieldStyleMobile = {
  width: "100% !important",
  marginLeft: "unset",
};

const searchFieldStyleMobileCoupon = {
  width: "unset",
  marginLeft: "unset",
  paddingLeft: "30px !important",
};

const headerButtonMobile = {
  padding: "6px 16px !important",
  width: "100% !important",
  marginTop: "12px",
};

const headerButton = {
  padding: "12px 24px !important",
};
const headerButtonExcelExport = {
  ml: "13px",
  height: "44px",
};
const reservationButtonCss = {
  p: "11px 24px",
  ml: "13px",
};
const listingTableMobile = {
  "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell.MuiDataGrid-cell--textLeft":
    {
      width: "unset !important",
      maxWidth: "unset !important",
      minWidth: "unset !important",
    },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "scroll !important",
  },
};
const grid1Style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
};

const businessListingPaperStyle = {
  borderRadius: "8px",
  background: "#E5E7EB",
  height: "100%",
  p: "24px 0px",
};

const businessListingCardStyle = {
  background: "#FFFFFF",
  border: "1px solid rgba(0, 0, 0, 0.16)",
  borderRadius: "8px",
};

const cardMediaStyle = {
  height: "56px",
  width: "56px",
  borderRadius: "8px",
  mr: "12px",
  p: "3px",
  border: "1px solid rgba(0, 0, 0, 0.12)",
  objectFit: "contain",
};

export {
  hideOnXS,
  hideOnSmMdLg,
  contentStyle,
  mainCardStyle,
  grid12Style,
  grid11Style,
  searchFieldStyle,
  grid1Style,
  businessListingPaperStyle,
  businessListingCardStyle,
  cardMediaStyle,
  searchFieldStyleMobile,
  headerButton,
  headerButtonMobile,
  searchFieldStyleMobileCoupon,
  listingTableMobile,
  headerButtonExcelExport,
  reservationButtonCss,
};
